import styled from "@emotion/styled";

export const StyledLabel = styled.label({ fontWeight: "bold" });

export const StyledLegend = styled.legend({ fontWeight: "bold" });
